import Swiper from 'swiper/bundle';

const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        mutation.target.disabled = mutation.target.classList.contains('swiper-button-disabled');
    });
});

(function () {
    const sliderElements = document.querySelectorAll('.swiper');
    if (sliderElements.length === 0) {
        return false;
    }

    function initSwiper(swiperElement) {
        console.log(swiperElement, swiperElement?.swiper);
        if (!window.neos && swiperElement.querySelectorAll('.swiper-slide').length < 2) {
            return false;
        }

        let slideChangeInterval = parseInt(swiperElement.dataset.interval) * 1000;

        let autoPlay = window.neos ? false : !!swiperElement.dataset.autoplay;
        if (autoPlay) {
            autoPlay = {
                delay: slideChangeInterval,
                disableOnInteraction: false
            };
        }

        if (swiperElement.dataset.interval) {
            swiperElement.style.setProperty('--swiper-navigation-progress-duration', swiperElement.dataset.interval + 's')
        }
        let portraitMode = !!swiperElement.dataset.portraitMode

        const nextButton = swiperElement.parentElement.querySelector('.swiper-btn-next');
        const prevButton = swiperElement.parentElement.querySelector('.swiper-btn-prev');

        let swiperParams = {
            breakpoints: {
                // default value
                slidesPerView: 1,
                // when window width is >= 640px
                640: {
                    // width: 640,
                    slidesPerView: 1,
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: portraitMode ? 2 : 1,
                },
                1295: {
                    slidesPerView: portraitMode ? 2 : 1.5,
                },
                // when window width is >= 1024px
                1551: {
                    slidesPerView: portraitMode ? 2 : 1.75,
                },
            },
            observer: true,
            setWrapperSize: true,
            autoplay: autoPlay,
            centeredSlides: false,
            spaceBetween: parseInt(swiperElement.dataset.spaceBetweenSlides),
            loop: !!swiperElement.dataset.loop,
            speed: parseInt(swiperElement.dataset.transition),
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            on: {
                observerUpdate: function (swiper) {
                    swiper.update();
                }
            }
        };

        if (!!swiperElement.dataset.teaserSlider) {
            swiperParams = {
                observer: true,
                setWrapperSize: true,
                autoplay: autoPlay,
                centeredSlides: true,
                spaceBetween: 0,
                loop: !!swiperElement.dataset.loop,
                speed: parseInt(swiperElement.dataset.transition),
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                pagination: {
                    el: swiperElement.parentElement.querySelector('.pagination-container'),
                    type: 'bullets',
                    clickable: true
                },
                on: {
                    observerUpdate: function (swiper) {
                        swiper.update();
                    }
                }
            };
        }

        observer.observe(prevButton, {
            attributes: true,
            attributeFilter: ['class']
        });

        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['class']
        });

        new Swiper(swiperElement, swiperParams);
    }

    sliderElements.forEach(initSwiper);

    document.addEventListener('Neos.NodeSelected', evt => {
        const swiper = evt.detail.element.closest('.swiper')?.swiper;
        if (swiper) {
            swiper.slideTo(swiper.slides.indexOf(evt.detail.element.closest('.swiper-slide')));
        }
    });
})();
